import axios from "axios";
import { getQueryString } from "../utils/function";
const devEnv = process.env.NODE_ENV !== "production";

const API = axios.create({
  baseURL: `${
    devEnv ? process.env.REACT_APP_DEV_API : process.env.REACT_APP_PROD_API
  }`,
  withCredentials: true,
});

API.interceptors.request.use((req) => {
  if (localStorage.getItem("accessToken")) {
    req.headers.Authorization = `Bearer ${localStorage.getItem("accessToken")}`;
  }
  return req;
});
// Authors
export const signUp = (formData) =>
  API.post("/auth/send-verification-code", formData);
export const signIn = (formData) => API.post("/auth/login", formData);
export const logout = () => API.post("/auth/logout");
export const changePassword = (data) =>
  API.post("/admin/change-password", data);

export const changeEmail = (data) => API.patch("/admin", data);

export const getAdmin = () => API.get("/admin");

export const getFileUrl = (data) => API.post("/upload", data);

export const getDashboardCardData = () => API.get("/reports/stats");

export const getStages = () => API.get("/purchase/all/stages");

export const getMerchant = (page = 0, search, activeType) => {
  const urlParams = new URLSearchParams();
  if (search !== "") {
    urlParams.append("search", search);
  }
  if (activeType !== "") {
    urlParams.append("status", activeType);
  }
  const query = getQueryString({
    skip: page * 9,
    take: 9,
  });
  const url = `/merchants?${query}&${urlParams.toString()}`;
  return API.get(url);
};

export const getTransactions = (page = 0, search, activeType, merchantId) => {
  const urlParams = new URLSearchParams();
  if (search !== "") {
    urlParams.append("search", search);
  }
  if (activeType !== "") {
    urlParams.append("status", activeType);
  }
  if (merchantId !== "") {
    urlParams.append("merchantId", merchantId);
  }
  const query = getQueryString({
    skip: page * 9,
    take: 9,
  });
  const url = `/payments?${query}&${urlParams.toString()}`;
  return API.get(url);
};

// Add for get purchase API's

// change user password
export const changeUserPassword = (form) =>
  API.patch("/admin/change-user-password", form);

// block user
export const blockUserAndSuspendById = (id, blockLabel) =>
  API.post(`/merchants/${id}/status`, blockLabel);

// update user
export const updateCategory = (categoryId, form) =>
  API.patch(`/categories/${categoryId}`, form);

// genarate jwt token as a user
export const generateJwt = (form) =>
  API.post("/auth/administrator/merchant-login", form);

// System wallet balances (network cards: BNB, Tron, MST, etc.)
export const getSystemWallets = () => API.get("/system/wallets");